import { trace, context, } from '@opentelemetry/api';
import { ATTR_MULTIPLAYER_HTTP_RESPONSE_BODY, ATTR_MULTIPLAYER_HTTP_RESPONSE_HEADERS, ATTR_MULTIPLAYER_HTTP_REQUEST_BODY, ATTR_MULTIPLAYER_HTTP_REQUEST_HEADERS, ATTR_MULTIPLAYER_RPC_REQUEST_MESSAGE, ATTR_MULTIPLAYER_RPC_RESPONSE_MESSAGE, ATTR_MULTIPLAYER_GRPC_REQUEST_MESSAGE, ATTR_MULTIPLAYER_GRPC_RESPONSE_MESSAGE, ATTR_MULTIPLAYER_MESSAGING_MESSAGE_BODY, } from '../constants/constants.base';
import mask, { sensitiveFields, sensitiveHeaders } from './mask';
/**
 * @description Set attribute to current span
 * @param {string} key
 * @param {AttributeValue} value
 * @returns {void}
 */
export var setAttribute = function (key, value) {
    var span = trace.getSpan(context.active());
    if (!span)
        return;
    span.setAttribute(key, value);
};
/**
 * @description Set request body to current span attributes
 * @param body
 * @param {{ mask: boolean }} options
 * @returns {void}
 */
export var setHttpRequestBody = function (body, options) {
    if (options === void 0) { options = { mask: true }; }
    var span = trace.getSpan(context.active());
    if (!span)
        return;
    if (options === null || options === void 0 ? void 0 : options.mask) {
        body = mask(sensitiveFields)(body, span);
    }
    span.setAttribute(ATTR_MULTIPLAYER_HTTP_REQUEST_BODY, body);
};
/**
 * @description Set request headers to current span attributes
 * @param body
 * @param {{ mask: boolean }} options
 * @returns {void}
 */
export var setHttpRequestHeaders = function (body, options) {
    if (options === void 0) { options = { mask: true }; }
    var span = trace.getSpan(context.active());
    if (!span)
        return;
    if (options === null || options === void 0 ? void 0 : options.mask) {
        body = mask(sensitiveHeaders)(body, span);
    }
    span.setAttribute(ATTR_MULTIPLAYER_HTTP_REQUEST_HEADERS, body);
};
/**
 * @description Set response body to current span attributes
 * @param body
 * @param {{ mask: boolean }} options
 * @returns {void}
 */
export var setHttpResponseBody = function (body, options) {
    if (options === void 0) { options = { mask: true }; }
    var span = trace.getSpan(context.active());
    if (!span)
        return;
    if (options === null || options === void 0 ? void 0 : options.mask) {
        body = mask(sensitiveFields)(body, span);
    }
    span.setAttribute(ATTR_MULTIPLAYER_HTTP_RESPONSE_BODY, body);
};
/**
 * @description Set response body to current span attributes
 * @param body
 * @param {{ mask: boolean }} options
 * @returns {void}
 */
export var setHttpResponseHeaders = function (body, options) {
    if (options === void 0) { options = { mask: true }; }
    var span = trace.getSpan(context.active());
    if (!span)
        return;
    if (options === null || options === void 0 ? void 0 : options.mask) {
        body = mask(sensitiveFields)(body, span);
    }
    span.setAttribute(ATTR_MULTIPLAYER_HTTP_RESPONSE_HEADERS, body);
};
/**
 * @description Set message body to current span attributes
 * @param body
 * @param {{ mask: boolean }} options
 * @returns {void}
 */
export var setMessageBody = function (body, options) {
    if (options === void 0) { options = { mask: true }; }
    var span = trace.getSpan(context.active());
    if (!span)
        return;
    if (options === null || options === void 0 ? void 0 : options.mask) {
        body = mask(sensitiveFields)(body, span);
    }
    span.setAttribute(ATTR_MULTIPLAYER_MESSAGING_MESSAGE_BODY, body);
};
/**
 * @description Set rpc request message to current span attributes
 * @param body
 * @param {{ mask: boolean }} options
 * @returns {void}
 */
export var setRpcRequestMessage = function (body, options) {
    if (options === void 0) { options = { mask: true }; }
    var span = trace.getSpan(context.active());
    if (!span)
        return;
    if (options === null || options === void 0 ? void 0 : options.mask) {
        body = mask(sensitiveFields)(body, span);
    }
    span.setAttribute(ATTR_MULTIPLAYER_RPC_REQUEST_MESSAGE, body);
};
/**
 * @description Set rpc response message to current span attributes
 * @param body
 * @param {{ mask: boolean }} options
 * @returns {void}
 */
export var setRpcResponseMessage = function (body, options) {
    if (options === void 0) { options = { mask: true }; }
    var span = trace.getSpan(context.active());
    if (!span)
        return;
    if (options === null || options === void 0 ? void 0 : options.mask) {
        body = mask(sensitiveFields)(body, span);
    }
    span.setAttribute(ATTR_MULTIPLAYER_RPC_RESPONSE_MESSAGE, body);
};
/**
 * @description Set grpc request message to current span attributes
 * @param body
 * @param {{ mask: boolean }} options
 * @returns {void}
 */
export var setGrpcRequestMessage = function (body, options) {
    if (options === void 0) { options = { mask: true }; }
    var span = trace.getSpan(context.active());
    if (!span)
        return;
    if (options === null || options === void 0 ? void 0 : options.mask) {
        body = mask(sensitiveFields)(body, span);
    }
    span.setAttribute(ATTR_MULTIPLAYER_GRPC_REQUEST_MESSAGE, body);
};
/**
 * @description Set grpc response message to current span attributes
 * @param body
 * @param {{ mask: boolean }} options
 * @returns {void}
 */
export var setGrpcResponseMessage = function (body, options) {
    if (options === void 0) { options = { mask: true }; }
    var span = trace.getSpan(context.active());
    if (!span)
        return;
    if (options === null || options === void 0 ? void 0 : options.mask) {
        body = mask(sensitiveFields)(body, span);
    }
    span.setAttribute(ATTR_MULTIPLAYER_GRPC_RESPONSE_MESSAGE, body);
};
//# sourceMappingURL=set-attribute.js.map